module.exports = __webpack_public_path__ + "static/media/swish_bw.e80eb711.png";